// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description = "A widget to displays multiple graphic tiles.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Media wall",
  id: "media-wall",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/media-wall/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "MediaWallConfigTool" */ "app/components/tools/MediaWallConfigTool/MediaWallConfigTool"),
    loading: DynamicImportLoader,
    modules: ["MediaWallConfigTool"]
  })
};

export default CONFIG;
